export default {"src":"/education/_next/static/media/left-circle-button.908baa87.svg","height":27,"width":15,"blurWidth":0,"blurHeight":0};